import { isPrivateNotesActivity } from "./privateNotesScope";
// Answer privacy is independent of presentation. Only text controls are supported.
export const isMappedInternalNotesId = id => typeof id === "string" && /^labelInternalNotes(?:_[A-Za-z0-9_-]+)?$/.test(id);
const wireTypes = { itemPrivateTextInput: "itemTextInput", itemPrivateTextInputMultiline: "itemTextInputMultiline" };
export const hasPrivateAnswerMarker = item => !!item && (item.saveAsPrivate === true || !!wireTypes[item.type]);
export const isSupportedPrivateText = item => !!item && ["textInput", "textInputMultiline", "itemTextInput", "itemTextInputMultiline", ...Object.keys(wireTypes)].includes(item.type);
export const isPrivateAnswerItem = (item, orgId, activity) => hasPrivateAnswerMarker(item) || (isPrivateNotesActivity(activity, orgId) && isMappedInternalNotesId(item?.id));
export function privateAnswerSourceId(item, orgId, activity) {
  if (isPrivateNotesActivity(activity, orgId) && isMappedInternalNotesId(item?.id)) return item.id;
  return typeof item?.guid === "string" && /^[A-Za-z0-9_-]{1,121}$/.test(item.guid) ? `field:${item.guid}` : null;
}
export function privateTextWireType(item) {
  return /multiline$/i.test(item.type) ? "itemPrivateTextInputMultiline" : "itemPrivateTextInput";
}
export function decodePrivateTextItems(value) {
  if (!value || typeof value !== "object") return value;
  if (wireTypes[value.type]) { value.type = wireTypes[value.type]; value.saveAsPrivate = true; }
  if (Array.isArray(value.children)) value.children.forEach(decodePrivateTextItems);
  return value;
}
export function collectPrivateAnswerIds(value, found = new Set()) {
  if (!value || typeof value !== "object") return found;
  if (hasPrivateAnswerMarker(value)) { found.add(value); [value.id, value.guid].forEach(id => { if (typeof id === "string" && id) found.add(id); }); }
  Object.values(value).forEach(child => { if (child && typeof child === "object") collectPrivateAnswerIds(child, found); });
  return found;
}

export function hasDuplicatePrivateSource(activity, item, orgId) {
  const sourceId = privateAnswerSourceId(item, orgId, activity);
  let matches = 0;
  const visit = node => {
    if (!node || typeof node !== "object") return;
    if (isPrivateAnswerItem(node, orgId, activity) && privateAnswerSourceId(node, orgId, activity) === sourceId) matches++;
    if (Array.isArray(node.children)) node.children.forEach(visit);
  };
  visit(activity);
  return matches > 1;
}
